import firebase from 'firebase';
import ReduxSagaFirebase from 'redux-saga-firebase';
import config from '../config';

const myFirebaseApp = firebase.initializeApp({
  apiKey: config.FIREBASE_API_KEY,
  authDomain: config.FIREBASE_AUTH_DOMAIN,
});

const reduxSagaFirebase = new ReduxSagaFirebase(myFirebaseApp);

export default reduxSagaFirebase;
